import React, { useState, useEffect } from "react";
import Select from "react-select";
import { getUsersApiUsageDropdwon } from "../../../../api";

const UserDropdown = ({
    isDisabled,
    selectedUsers,
    setSelectedUsers,
    selectedEnterprise,
  }: {
    isDisabled: boolean;
    selectedUsers: any[];
    selectedEnterprise: number | null;
    setSelectedUsers: (users: any[]) => void;
  }) => {
    const [userOptions, setUserOptions] = useState([]);
    const [selectedData, setSelectedData] = useState<any[]>([]);
  
    useEffect(() => {
      if (selectedEnterprise !== null) {
        getUsersApiUsageDropdwon(selectedEnterprise).then((response: any) => {
          if (Array.isArray(response.data)) {
            const options = response.data
              .map((user) => ({
                value: user.id,
                label: user.name,
              }));
            setUserOptions(options);
          }
        });
      }
      else {
        // Reset when no enterprise is selected
        setUserOptions([]);
        setSelectedData([]);
        setSelectedUsers([]);
      }
    }, [selectedEnterprise]);
  
    const handleChange = (selected: any) => {
      setSelectedData(selected);
      const selectedValues = selected.map((item: { value: string }) => item.value);
      setSelectedUsers(selectedValues);  
    };

  
    const customStyles = {
      control: (base, state) => ({
        ...base,
        width: '200px',
        minHeight: '50px',
        maxHeight: '60px',
        overflowY: 'auto',
        flexWrap: 'wrap',
      }),
      menu: (base) => ({
        ...base,
        width: '200px',
      }),
      multiValue: (base) => ({
        ...base,
      }),
      multiValueLabel: (base) => ({
        ...base,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }),
      multiValueRemove: (base) => ({
        ...base,
        color: 'red',
        cursor: 'pointer',
        ':hover': {
          backgroundColor: '#ffe6e6',
        },
      }),
    };
  
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px' }}>
        <Select
          isMulti
          options={userOptions}
          value={selectedData}
          onChange={handleChange}
          isDisabled={isDisabled}
          placeholder="Select Users..."
          styles={customStyles}
        />
      </div>
    );
  };
  

export default UserDropdown;
